<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="견적요청 조회"
      desc="현재 신규로 들어온 견적요청내역을 확인할 수 있습니다.
            고객들의 견적서 대기시간이 짧을수록 서비스 퀄리티가 좋아집니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 nextPageName="nopage"
                 :table_width="1200"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="estimate_content" slot-scope="props" style="width: 120px; margin: auto;">
        <div @click.stop.prevent="clickEst(props.item)" style="cursor: pointer">
          <i class="material-icons">library_books</i>
        </div>
      </div>


      <div slot="estimate_status" slot-scope="props" style="width: 120px; margin: auto;">
        <div v-if="props.item.status=== 1">견적 대기중</div>
        <div v-if="props.item.status=== 2">견적 완료</div>
        <div v-if="props.item.status=== 3">주문 대기</div>
        <div v-if="props.item.status=== 4">주문 승인</div>
        <div v-if="props.item.status=== 5">주문 확정</div>
        <div v-if="props.item.status=== 101">견적 취소</div>
        <div v-if="props.item.status=== 102">주문 취소</div>

        <button v-if="props.item.status=== 0"
                class="button state-btn ests-btn-confirm-new"
                @click.stop.prevent="clickStatus(props.item,'confirm-new')">신규요청확인</button>
        <button v-if="props.item.status < 4"
                class="button"
                style="margin-top:8px"
                @click="openCancelModal(props.item.id)">견적 취소</button>
      </div>

      <div slot="estimate_button" slot-scope="props">
        <button class="button state-btn ests-btn-request-sheet"
                v-if="$store.getters.mode==='admin'"
                @click.stop.prevent="clickStatus(props.item,'request-sheet')">견적서 의뢰</button>
        <button class="button state-btn ests-btn-write-sheet"
                style="margin-top:8px"
                v-if="props.item.status<2"
                @click.stop.prevent="clickStatus(props.item,'write-sheet')">견적서 작성</button>
      </div>
    </admin-table>

    <modal name="cancelModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div>견적을 취소하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="cancelEstimate">확인</button>
        </div>
      </div>
    </modal>

    <!--<sweet-modal overlay-theme="dark" ref="deleteModal">
      <lp-modal>
        <span slot="title"> </span>
        <span slot="desc"> 견적을 삭제하시겠습니까?</span>
        <span slot="ok" @click="deleteItem">확인</span>
        <span slot="cancel" @click="$refs.deleteModal.close()">취소</span>
      </lp-modal>
    </sweet-modal>-->

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpModal from "../../../module/common/LpModal";

  export default {
    name: 'RequestNew',
    components: {LpModal},
    mixins: [
      ListMixin
    ],

    computed: {
      partnerName(){
        let partner_id;
        if(this.selectedItem){
          partner_id = this.selectedItem.partner_id;
        }
        else if(this.requestItem){
          partner_id = this.requestItem.partner_id;
        }
        let partner = find(this.partners, 'value', partner_id);
        if(partner !== undefined)
          return partner.name;
        else
          return '';
      }
    },

    data () {
      return {
        selectedItem: undefined,    // 팝업으로 표시할 선택된 아이템
        requestItem:undefined,
        partners: [],
        cancelId: 0
      }
    },

    created () {
      this.init();
    },

    methods: {
      init() {
        this.initializing('request_new', 'estimate/request?status=0');
      },
      getDataFromServer() {
        this.getData();
      },
      openCancelModal (id) {
        this.cancelId = id;
        this.$modal.show('cancelModal');
      },
      cancelEstimate () {
        this.$axios.post(this.getUrl(`estimate/request/${this.cancelId}/cancel`))
          .then(res => {
          if(res.status===200) {
            this.toast('취소 완료되었습니다.');
            this.$modal.hide('cancelModal');
            this.getData();
          }
        })
      },
      clickStatus(item, kind) {
        if (kind === "confirm-new") {
          this.chkReq(item);
        }
        else if (kind === "request-sheet") {
          this.clickAddRequest(item);
        }
        else if (kind === "write-sheet") {
          this.clickAddBid(item);
        }
      },

      // 견적요청서 보기
      clickEst(item) {
        this.$axios.get(this.getUrl('estimate/request/'+item.id)).then(res=>{
          if(res.status===200){
            this.selectedItem = res.data;

            let value = {
              selectedItem: this.selectedItem
            }
            this.$store.commit('openModal', {type:'modal-order-content', value: value});
          }
        })
      },

      // 견적 상태 - 신규요청확인 클릭
      chkReq(item) {
        this.$axios.post(this.getUrl('estimate/request/'+item.id+'/receipt'),{
          status:1
        }).then(res => {
          if(res.status===200){
            item.status = 1;
          }
        });
      },

      // 의뢰하기
      clickAddRequest(item, bid) {
        this.requestItem = {
          request_id: item.id,
          partner_id: '',
          note:'',
          files:''
        };

        let value = {
          requestItem: this.requestItem
        }
        this.$store.commit('openModal', {type:'modal-request-partner', value:value})
      },

      //견적서 등록
      clickAddBid(item) {
        this.selectedItem = {
          bid_info: item.bid_info,
          request_id: item.id,
          form_id: item.form,
          request: item.request,
          price: '',
          note: '',
          price_info: [],
          user: '',
          created_time: '',
          files:[]
        };

        this.$store.commit('openModal', {type:'modal-write-order', value:this.selectedItem})

      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main';
  .tr-whole-border th
    padding 12px 6px

  .many-field-tr td
    padding 6px

  .progress-btn
    border-radius 3px
    display inline-block
    width 84px
    padding 6px 0
    margin 2px
    font-weight bold
    font-size .8rem

  .bid-state
    margin 2px 0
    color #fff
    border-radius 3px
    display inline-block
    width 76px
    padding 4px

  .btn-request-sheet
    color white
    background-color #5cb85c

  .bid-state-done
    background-color #5cb85c
  .bid-state-ing
    background-color #1c7cd5
  .bid-state-ok
    background-color #5cb85c
  .bid-state-no
    background-color #f0ad4e

  .q-title
    font-size 0.9rem
    color $primary
    margin-top 20px
    margin-bottom 4px

  .est-title
    padding 20px
    font-size 1.2rem
    border-bottom 1px solid $primary

  .est-table
    padding 20px
    max-height 80vh

  .est-table table
    width 100%

  .est-table table
  .est-table th
  .est-table td
    border 0
    padding 4px 0
    text-align center

  .modal-title
    margin 20px 0 8px 0
    color #064160
    font-size 0.9rem
    font-weight bold

  .modal-desc
    padding 20px
    background-color #eee

  .td-est:hover
    background-color #eeeeee
    cursor pointer

  .lp-btn-bid
    cursor pointer
    border-radius 3px
    color white
    padding 4px 6px
    font-size 0.8rem
    width 74px
    margin auto
    margin-top 4px
    background-color $primary

  .btn-add
    width 24px
    height 24px
    line-height 23px
    text-align center
    font-size 1rem
    color white
    background-color $primary
    border-radius 50%

  .lp-custom-modal-btns
    padding 20px

  .btn-close
    width 45px
    color #777
    text-align center
    margin auto 0
</style>
